import "./Navbar.css";

const Navbar = () => {
  return (
    <nav>
      <div className="logo">Vishaal.</div>

      <ul className="nav-links">
        <li><a href="#home">Home</a></li>
        <li><a href="#projects">Projects</a></li>
        <li><a href="#skills">Skills</a></li>
      </ul>

      <div className="nav-right">
        <a href="/Resume.pdf" target="_blank" rel="noreferrer" className="resume-link-mobile">
          Resume
        </a>
        <a href="#contact">
          <button className="contact-btn">Contact</button>
        </a>
      </div>
    </nav>
  );
};

export default Navbar;